<template>
  <div id="cashierdiary" class="public-content">
    <!-- 公共form表单样式 -->
    <div class="form-item-public">
      <el-form inline label-position="left" :model="formData" class='clearfix'>
        <el-form-item label="日记账">
          <div class='cashierdiaryTips' v-if="cashierdiaryTipsShow"></div>
          <el-select
            placeholder="请选择" size="small"  @change="getData1"
            v-model="formData.fkJournalAccountId" :clearable="false" filterable
            :disabled='ProhibitClick'
          >
            <el-option v-for="(item,index) in dictListCode.account" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" class='rangeDate'>
          <el-date-picker
            v-model="dateList"
            type="monthrange"
            range-separator="至"
            size='small'
            style="width:260px"
            value-format="yyyyMM" format="yyyy年MM期"
            start-placeholder="开始月份"
            @change='getDataChange'
            end-placeholder="结束月份">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="text"  size="small" @click="deleteAlls" v-for='i in buttonList_d' :key='i.id'>{{i.label}}</el-button>
          <el-button type="text"  size="small" @click="openRecycleBin" style='color: #D0021B;'>回收站</el-button>
        </el-form-item>
        <el-form-item class="fr lineHeight" >
             <div class="table-oper">
                <span class="menu-btn">
                  <el-button size='small' type='default'>
                    显示/隐藏列 <i class='el-icon-arrow-down'></i>
                  </el-button>
                  <div class="menu-wrapper">
                    <vxe-checkbox
                        class="checkbox-item allChange"
                        v-model='refreshColumnChange'
                        @change="handleRefreshColumnChange">全选</vxe-checkbox>
                    <template v-for="(column,index) in table.customColumns">
                      <vxe-checkbox
                        v-if="column.property"
                        class="checkbox-item"
                        v-model="column.visible"
                        :key="index"
                        :disabled='column.title==="日期" || column.title==="摘要"'
                        @change="$refs.vxeTable.$children[0].refreshColumn()">{{ column.title }}</vxe-checkbox>
                    </template>
                  </div>
                </span>
              </div>
        </el-form-item>
        <el-form-item class="fr">
         <!--  <el-button size="small" @click="insideTransferAccounts" class='minButton' v-if='true'>内部转账</el-button> -->
          <el-button size="small" @click="addCashierdiary" class='minButton' v-if='true'>添加日记账</el-button>
          <div v-for="item in buttonList" style='display: inline-block;padding-left:10px;' :key='item.id'>
              <el-button size="small"  @click='handleClickOperation(item)'>{{item.name}}</el-button>
          </div>
          
        </el-form-item>
        
				
      </el-form>
    </div>
    <!-- 新增框 :picker-options="pickerOptions()"-->
    <transition name = "fade">
      <el-row v-if='isFastAddShow'>
        <el-col>
          <div class="addDiary-content">
            <el-form inline label-position="top" :model="formAdd" ref='addFormRef' :rules="valides">
              <el-form-item label="日期" prop="date">
                <el-date-picker
                  @keyup.enter.native="keyUpEnterDown('date')" @change="keyUpEnterDown('date')"
                   :clearable='false'
                  :editable="false" ref="dateRef"
                  @blur="keyUpEnterDown('date')"

                  v-model="formAdd.date" type="date" value-format="yyyy-MM-dd" placeholder="请选择日期" size="small"></el-date-picker>
              </el-form-item>
              <el-form-item label="摘要" prop="summary">
                <el-input
                  @keyup.enter.native="keyUpEnterDown('summary')"
                   @clear="hanleClearInput('summary')"
                  ref="sumaryRef" clearable autofocus
                  style="width:3.60rem"
                  v-model="formAdd.summary"  size="small" placeholder="输入  ↵"></el-input>
              </el-form-item>
              <el-form-item label="收入" prop="debitMoney">
                 <el-input
                  @keyup.enter.native="keyUpEnterDown('debitMoney')" @keyup.native="filters('debitMoney')"
                  @blur='handleOnlyOne("debitMoney")'
                   @clear="hanleClearInput('debitMoney')"
                  ref="debitMoneyRef" clearable
                  style="width:2.4rem"
                  v-model="formAdd.debitMoney" size="small" placeholder="输入  ↵"></el-input>
              </el-form-item>
              <el-form-item label="支出" prop="creditorMoney">
                <el-input
                style="width:2.4rem"
                 @keyup.enter.native="keyUpEnterDown('creditorMoney')" @keyup.native="filters('creditorMoney')"
                  @blur='handleOnlyOne("creditorMoney")'
                   @clear="hanleClearInput('creditorMoney')"
                 ref="creditorMoneyRef" clearable
                 v-model="formAdd.creditorMoney" size="small" placeholder="输入  ↵"></el-input>
              </el-form-item>
              <el-form-item label="备注(选填)" prop="remarks">
                <el-input
                 @keyup.enter.native="keyUpEnterDown('remarks')"
                 @clear="hanleClearInput('remarks')"
                 ref="remarksRef" clearable
                 v-model="formAdd.remarks"  size="small" placeholder="保存  ↵" style="width:4rem"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size='small' class='saveRjzBtn' @click='saveRjzBtnClick'>确认</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
       
      </el-row>
    </transition>
		<!-- 公共table 样式 -->
		<div class="flexTable" :style='tableTop'>
      <vxe-table :table="table" @successSave="successSave" @seeRowEventRow='seeRowEventRow' @idList='idList' 
       ref='vxeTable' v-if='isVxeTableShow'  :tableData='tableData' @on-change-data='changeTableData'
       ></vxe-table>
			
		</div>
   

      <!-- 打印弹框 -->
      <el-dialog title="打印设置" :visible.sync="printDialogShow" width="520px" :close-on-click-modal="false" id='printDialog_ss'>
        <div class='print_container'>
          <div>
            <span class='printTitle'>打印范围：</span>
            <div style='margin-top: 20px;margin-left: 10px;'>
                 <el-radio v-model="printFormData.exportScope" label="1">当前勾选</el-radio>
                 <el-radio v-model="printFormData.exportScope" label="2">当前期间全部</el-radio>
            </div>
            
          </div>
          <div style='margin-top: 20px;'>
            <span class='printTitle'>打印内容：</span>
            <div style='margin-top: 20px;margin-left: 10px;'>
                <el-checkbox-group v-model="printFormData.checkList" >
                  <el-checkbox v-for='item in PDFcustomList' :label="item.id" :disabled='item.type' :key='item.id'>{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div>
          </div>
          <div style='margin-top: 20px;text-align: right;'>
            <el-button size="small" class='minButton' @click='handlePrint("")'>打印</el-button>
          </div>
        </div>
      </el-dialog>

       <!-- 导出弹框 -->
      <el-dialog title="导出设置" :visible.sync="exportDialogShow" width="520px" :close-on-click-modal="false" id='printDialog_ss'>
        <div class='print_container'>
          
           <div>
            <span class='printTitle'>导出类型：</span>
            <div style='margin-top: 20px;margin-left: 10px;'>
                 <el-radio v-model="printFormData.exportScope" label="1">当前勾选</el-radio>
                 <el-radio v-model="printFormData.exportScope" label="2">当前期间全部</el-radio>
            </div>
            
          </div>
          <div style='margin-top: 20px;'>
            <span class='printTitle'>导出范围：</span>
            <div style='margin-top: 20px;margin-left: 10px;'>
                 <el-radio v-model="printFormData.exportType" label="1">导出Excel</el-radio>
                 <el-radio v-model="printFormData.exportType" label="2">导出单据PDF</el-radio>
            </div>
            
          </div>
          <div style='margin-top: 20px;'>
            <span class='printTitle'>导出内容：</span>
            <div style='margin-top: 20px;margin-left: 10px;'>
                <el-checkbox-group v-model="printFormData.checkList" >
                  <el-checkbox v-for='item in PDFcustomList' :label="item.id" :disabled='item.type' :key='item.id'>{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div>
          </div>
          <div style='margin-top: 20px;text-align: right;'>
            <el-button size="small" class='minButton' @click='handlePrint("export")'>导出</el-button>
          </div>
        </div>
      </el-dialog>
      <!-- 导入日记账 -->
      <el-dialog
        title="导入日记账" :visible.sync="importFiles" width="600px" :close-on-click-modal="false" class='RJZ_dialog'>
        <div v-loading='isImportFilesLoading' element-loading-text="正在上传文件...">
          <div class="fliesUplaod"  >
            <div class='stepOne'>
                <h4 class='color333'>步骤1：配置自定义表单</h4>
                <p>您需要先配置好您的表单内容：点击“添加日记账”-“配置表单”设置所需自定义列；</p>
            </div>
            <div class='stepTwo'>
                <h4 class='color333'>步骤2：导出模板</h4>
                <p>按当前自定义表单导出模板：<el-button type="text" class='handleDownload' @click='rjz_handleDownload_MB'>点击下载模板</el-button></p>
            </div>
            <div class='stepThree'>
                 <h4 class='color333'>步骤3：导入表单</h4>
                   <div class="uploads">
                      <el-upload
                        drag
                        action="https://jsonplaceholder.typicode.com/posts/"
                        :show-file-list='true'
                        :auto-upload="false"
                        :on-change="OnChange"
                        :on-remove="OnRemove"
                        :before-remove="beforeRemove"
                        :limit='handleLimit'
                        ref='upload'
                        >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" slot="tip">只能上传.xls/.xlsx文件，且不超过5M</div>
                      </el-upload>
                    </div>
            </div>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" class='minButton' @click="handleUploadAdd">确定导入</el-button>
          </div>
        </div>
      </el-dialog>

      <!-- 添加日记账 -->
      <cashierdiary-dialog :showVisible.sync="showVisible" @configHeader='configHeader' :dictListCode='dictListCode'
          @successSave="successSave" :formData='formData' @fastChangeMsg='fastChangeMsg' :nowRow='nowRow' 
          @handleSelectChangeId = 'handleSelectChangeId' @successSaveHightLight='successSaveHightLight'
         
         >
        
      </cashierdiary-dialog>
      <!-- 回收站 -->
      <recycle-bin
        :recycleBinVisible.sync="recycleBinVisible"
        :dateList='dateList'
        :del_useList='del_useList'
      ></recycle-bin>

      <!-- 日记账账户没有 -->
      <el-dialog
          title="提示"
          :visible.sync="cashierdiaryTipsShow"
          width="600px"
          :close-on-click-modal='false'
          :close-on-press-escape="false"
          :show-close='false'
          class='handleSetUserStyle'
          >
          <span style='color: red'>
            系统检测到您还没有设置账户，请在“出纳-账户”设置出纳账户或点击
            <el-button type='text' @click='handleSetUser'>设置账户</el-button>
            设置账户
          </span>
          <div style='text-align: right'>
            <el-button size='small' type='primary' @click='cashierdiaryTipsShow=false'>我知道了</el-button>
          </div>
      </el-dialog>
	</div>
</template> 
<script>
  import {currencys} from '@/assets/utils/currencyFormat'
  import cashierdiaryDialog from "@/components/dialog/addCashierdiaryDialog"
  import recycleBin from "@/components/dialog/recycleBin"
  import vxeTable from "@/components/vxeTable"
  export default{
    components:{
      cashierdiaryDialog,
      vxeTable,
      recycleBin
    },
    data(){
      return {
        firstGetTable: true,   // 是否为第一次请求表格
        exportDialogShow:false,     // 导出弹框 
        PDFcustomList:[],     // 打印内容
        printFormData:{   // 打印参数
          exportScope:"2",
          checkList:[],
          exportType:"1"
        },
        printDialogShow:false,  // 打印
        del_useList:[],    // 回收站用的账户数据
        recycleBinVisible:false,    // 回收站显示
        tableTop:{top:'87px'},
        cashierdiaryTipsShow: false,  // 日记账提示框是否显示
        refreshColumnChange: true,  // 自定义显示列是否全选
        dateList:[],       // 会计期间
        isVxeTableShow: true,     // 表格是否显示
        nowRow: {},          // 当前编辑行
        isFastAddShow: false,       // 是否开启快速面板
        table: {     // 表格
          customColumns:[],  // 自定义显示列
          dateChange: false,// 表格数据是否变化
            hasSelect: true,     // 是否显示多选
            hasShowSummary: true,    // 是否显示合计行
            loading: false,    // 是否显示loading
            config: [],
            data:[],
            tablePage: {
                currentPage: 1,
                pageSize: 10,
                totalResult: 0
             },
            footerMethod:this.footerMethod,
            editClosedEvent: this.editClosedEvent  // 自定义编辑方法
        },
        isSearchShow: true,    // 是否显示
        showVisible: false,      // 添加日记账显示
        isFirstActive: false,
        firstHit: true,   // 收入支出为零提示一次
        changeFocus: false,  // 点击收入支出切换
        ProhibitClick: false,    // 禁止操作
        handleLimit: 1,        // 上传文件数
        isImportFilesLoading: false,
        fileList:[],       // 传入文件列表
        importFiles: false,      // 导入控制
        buttonList: [],      // 按钮权限
        buttonList_d:[],
        ids:[],
        newAdd:true,
        newAdds:false,        // 是否是新增高亮最后一行
        tableLoading:false,
        loadingText:'查询列表数据中',  
        edtBeginning:true,

        page:{
          pageIndex:1,
          pageSize:10,
          totall:0,
        },
        tableData:[],
        fitterData:[],
        formData:{
            date:'',
            startYearPeriods: "",
            endYearPeriods: "",
            fkJournalAccountId:'',
            orderBy:'date ASC,',    // date DESC,  // 降序 date ASC,// 升序
        },
        formAdd:{
            date:null,
            summary:'',
            debitMoney:'',
            creditorMoney:'',
            remarks:'',
        },
        valides:{
          date:[{required:true,message:'日期必须选择！'}],
          summary:[{required:true,message:'摘要必须填写！',trigger:'change'}],
         // debitMoney:[{validator:moneys,trigger:'blur'},{validator:moneys,trigger:'change'},],
         // creditorMoney:[{validator:moneys,trigger:'blur'},{validator:moneys,trigger:'change'},]
        },

        formAddAmount:{
            isBeginning:'1',
            remainingSum:'',
            fkJournalAccountId:''
        },
        dictListCode:{
          account:[]
        },
        nums:'',
        imgStyle: {
          display: 'inline-block',
          width: '12px',
          height: '12px',
          marginLeft:'5px',
          marginBottom:'3px',
        },
        iconName: 'ascendingorder',

         clickChange: true,         // 点击切换

      }
    },
    methods:{
      // 内部转账
      insideTransferAccounts() {
        
      },
      // 获取自定义选择列
      getPDFcustom() {
         this.$http.post('custom/getPDFcustom',{}).then(res=>{
            if(res && res.data.code == 1) {
              this.PDFcustomList = res.data.data;
               this.printFormData.checkList=[];
              if(this.PDFcustomList&&this.PDFcustomList.length) {
                 this.PDFcustomList.forEach(i=>{
                    this.printFormData.checkList.push(i.id);
                 })
              }
            }
         })
      },
      // 操作按钮点击
      handleClickOperation(row) {
        
        if(row.permission === "ac:diary:print") {  // 打印
            this.printDialogShow = true;
        }else if(row.permission === "ac:diary:export") { // 导出
          this.exportDialogShow = true;
        }else if(row.permission === "ac:diary:import") {  // 导入
          if(!this.formData.fkJournalAccountId) {
            return this.$message.warning('日记账账户不能为全部，请重新选择')
        }
            this.handleImport();
        }
      },
      //打开回收站
      openRecycleBin() {
          this.recycleBinVisible = true;
      },
      // 改变table的data值
      changeTableData(val) {
        this.table.data = val;
      },
      // 自定义列显示全选
      handleRefreshColumnChange() {
        let data = this.$refs.vxeTable.$children[0].collectColumn;
          if(data.length) {
              data.forEach(i=>{
                console.log(i)
                i.visible = this.refreshColumnChange;
                if(i.type==="selection"){i.visible=true}
                if(i.title==="摘要"){i.visible=true}
                if(i.title==="日期"){i.visible=true}
                if(i.title==="操作"){i.visible=true}
              })
          }
          this.$refs.vxeTable.$children[0].refreshColumn();
      },
      // 保存成功高亮最后一行
      successSaveHightLight(data){ 
          if(data) {
             this.newAdds = true;
              this.formData = Object.assign(this.formData,{
                startYearPeriods: data,
                endYearPeriods: data,
              })
              this.dateList = [data,data];
              this.getData();

              this.$refs.vxeTable.scrollBottomFun();

          }
      },
      // 翻页
      // handlePageChange(data) {
      //     this.table.tablePage.currentPage = data.currentPage;
      //     this.table.tablePage.pageSize = data.pageSize;
         
      //     this.findList(data.currentPage,data.pageSize,data.tableData);
      // },
      // findList(pageNo,pageSize,tableData) {
      //     tableData=tableData?tableData:this.tableData;
      //     this.table.data = tableData.slice((pageNo-1)*pageSize,pageNo*pageSize)
      // },
      idList(data) {
        this.ids = data;
      },
      // 接收子组件账户切换ID
      handleSelectChangeId(data) {
        this.formData.fkJournalAccountId = data;
        this.getData1(data);
      },
      // 接收查看方法传过来的数据
      seeRowEventRow(data) {
          if(data) {
            this.nowRow = data;
            this.showVisible = true;
          }
      },
      // 是否开启快速面板
      fastChangeMsg(data) {
        if(data) {
          this.tableTop.top = "200px";
        }else {
          this.tableTop.top = "87px";
        }
        this.isVxeTableShow = false;
        this.$nextTick(()=>{
          this.isVxeTableShow = true;
        })
        this.isFastAddShow = data;
      },
      // 保存快速添加
      saveRjzBtnClick() {
        this.saveJournalPeriod(this.formAdd,false);
      },
      // 子组件保存成功返回
      successSave(data) {
        if(data) {
          this.getData();
           this.getPDFcustom();
        }
      },
      // 自定义头部数据
     configHeader(data) {
      if(data.length) {
          this.table.config = data;
           this.isVxeTableShow = false;
          this.$nextTick(()=>{
            this.isVxeTableShow = true;
          })
        }
     },
      // 编辑关闭
      editClosedEvent ({ row, column }, event) {
        this.newAdds = false;
       if(!this.table.dateChange) {
            return    // 如果没有修改列表，返回
       }
        this.table.loading = true;
           let da=[];
          for(var i in row) {
           let is= i.split("-");
              if(is[0] === 'value'){
                let obj=new Object();
                 obj.id= is[1];
                if(row[i]&&row[i].id){
                  if(typeof(row[i].id) === "string"){
                      obj.value=row[i].id
                  }else {
                      obj.optionListValue=row[i].id
                  }
                }else if(row[i].customType==5){
                  obj.imgList = row[i].imgList?row[i].imgList:[]
                }else{
                  obj.value=row[i].value?row[i].value:row[i];
                }
                obj.customType = row[i].customType;
                 da.push(obj)
              }
          }

          row.customColumnList=da;
          this.saveJournalPeriod(row,true);
      },
       
      footerMethod ({ columns, data }) {
              let sum="",arr=['debitMoney', 'creditorMoney']; 
              return [
                columns.map((column, columnIndex) => {
                  
                  if (columnIndex === 1) {
                    return '全部合计'
                  }
                  if (columnIndex === 2) {
                    return '共'+(data.length===0?0:data.length-1)+"条数据"
                  }
                 if(column.params!==undefined&&column.params.isTotal===1) {
                    arr.push(column.property);
                 }
                  if (arr.includes(column.property)) {
                      const values = data.map(item => {
                        if(typeof(item[column.property])==="object") {
                          return Number(item[column.property].value)
                        }else {
                            return Number(item[column.property])
                        } 
                      });
                      if (!values.every(value => {isNaN(value)})) {
                          sum = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if(!isNaN(value)) {
                                if(!(parseFloat(prev)+parseFloat(curr))) {
                                      return 0;
                                    }else {
                                      
                                        return (parseFloat(prev)+parseFloat(curr)).toFixed(2);
                                    }
                            }else {
                              
                                        return parseFloat(prev).toFixed(2);
                                  
                              }
                         })
                      }else {
                        sum = "";
                      }
                      return currencys(sum);
                  }
                 
                })
              ]
            },
      // 添加如记账
      addCashierdiary() {
        this.nowRow={ superMarket:true };
        this.showVisible = true;
      },



      // 点击表格全选
      selectAll(row , type) {
        const _=this;
          switch(type) {
           case "summary":
               _.$refs.summaryRefs.select();
               break;
            case "debitMoney":
               _.$refs.debitMoneyRefs.select();
               break;
            case "creditorMoney":
               _.$refs.creditorMoneyRefs.select();
               break;
            case "remarks":
               _.$refs.remarksRefs.select();
               break;
            case "remainingSum":
                  _.$refs.remainingSumRefs.select();
                break;
            default: 
              return;
              break;

          }
      },
      // 快速添加清空
      hanleClearInput(type) {
        const _ = this;
          switch(type){
            case "summary":
               _.$refs.sumaryRef.focus();
               break;
            case "debitMoney":
               _.$refs.debitMoneyRef.focus();
               break;
            case "creditorMoney":
               _.$refs.creditorMoneyRef.focus();
               break;
            case "remarks":
               _.$refs.remarksRef.focus();
               break;
             default: 
              return;
              break;
          }
      },
      // 自定义表头
      renderHeader(h,{column}) {
          return h("span",{
            class: 'click_container',
            on:{
              click: ()=>{
                this.$set(this.imgStyle , 'display' , 'inline-block');
                if(!this.clickChange) {
                  this.iconName = 'descendingorder'
                  this.clickChange=!this.clickChange;
                  this.$set(this.formData,"orderBy",'date ASC,');
                  this.getData();
                }else {
                  this.iconName = 'ascendingorder'
                  this.clickChange=!this.clickChange;
                  this.$set(this.formData,"orderBy",'date DESC,');
                  this.getData();
                }
              }
            }
          }, [
                h("span", ['日期']),
                h("img", {
                attrs: {
                          'src': "/static/icon/"+`${this.iconName}`+".svg"
                },
                style: this.imgStyle,

                    })
            ])

      },
      // 收入支出失去焦点
      handleOnlyOne(type) {
        let _ = this;
        if(type=="debitMoney") {
            if(_.formAdd.debitMoney != '') {
                if(!Number(_.formAdd.debitMoney)) {
                    _.formAdd.debitMoney = "";
                }else {
                    _.formAdd.creditorMoney = '';
                     _.formAdd.debitMoney = parseFloat(_.formAdd.debitMoney).toFixed(2);
                     _.$refs.remarksRef.focus();
                  }
            }else {
                _.$refs.creditorMoneyRef.focus();
            }
        }else if(type=="creditorMoney") {
             if(_.formAdd.creditorMoney != '') {
               if(!Number(_.formAdd.creditorMoney)) {
                    _.formAdd.creditorMoney = "";
                }else {
                     _.formAdd.debitMoney = '';
                     _.formAdd.creditorMoney = parseFloat(_.formAdd.creditorMoney).toFixed(2);
                     _.$refs.remarksRef.focus();
                  }
            }else {
               // _.$refs.debitMoneyRef.focus();
            }
        }else if(type=="remainingSum") {
             _.formAddAmount.remainingSum= _.formAddAmount.remainingSum.toString().replace(/\,/g,"");
            _.formAddAmount.remainingSum = parseFloat(_.formAddAmount.remainingSum)
            if(isNaN(_.formAddAmount.remainingSum)) {
                _.formAddAmount.remainingSum = "";
            }
             _.saveJournalPeriodsrow();
            
        }
      },
      // 导入点击
      handleImport() {
        const prevent =  this.$getSessionStorage('superPreventOperation');
        if(prevent) {
          this.$store.commit('SUPERPREVENTFUNCTION',true);
          return;
        }
        if(this.ProhibitClick) {
          return;
        }
          this.importFiles = true;
      },
      // 移出提示
      beforeRemove(file, fileList) {
           return this.$confirm(`确定移除 ${ file.name }？`);
        },
      // 传入文件监听
      OnChange(file,fileList){
        this.fileList=fileList
      },
      // 移出操作
      OnRemove(file,fileList){
        this.fileList=fileList
      },
      // 确认导入
      handleUploadAdd() {
        this.params = new FormData();
        // 导入验证 
        if(this.fileList.length>1) {
          return this.$message.warning('只能从列表选择一个上传哟!')
        }
        if(!this.fileList.length) {
          return this.$message.warning('请选择上传文件!')
        }
        let fileOne = this.fileList[0];
        let testmsg=fileOne.name.substring(fileOne.name.lastIndexOf('.')+1)
        const extension = testmsg === 'xls'
        const extension2 = testmsg === 'xlsx'
        const isLt5M = fileOne.size / 1024 / 1024 < 5
        if(!extension && !extension2) {
          return this.$message({
            message: '上传文件只能是 xls、xlsx格式!',
            type: 'warning'
          });
        }
        if(!isLt5M) {
          return this.$message({
            message: '上传文件大小不能超过 5MB!',
            type: 'warning'
          });
        }

         this.params.append('fkJournalAccountId',this.formData.fkJournalAccountId);
         this.params.append('date',this.formData.date);
         this.params.append('multipartFile',fileOne.raw);
         this.params.append('cid',sessionStorage.getItem('cid'));
         this.params.append('token',sessionStorage.getItem('token'));
        // console.log(this.params.get('multipartFile'))
        // console.log(this.params.get('isArrangement'))
         try {
          const instance = this.$http.create({
            withCredentials: true
          })
          this.isImportFilesLoading = true;

          instance.post(this.$rootUrl + 'journal/importFileJournalPeriod', this.params).then(res=>{
            if(res && res.data.code == 1) {
              this.isImportFilesLoading = false;
              this.importFiles = false;
              this.$message.success(res.data.msg)
              this.fileList=[];
              this.$refs.upload.clearFiles();
              this.getData();
            }else {
              this.isImportFilesLoading = false;
              this.fileList=[];
               this.$message.error(res.data.msg)
              this.$refs.upload.clearFiles();
              this.importFiles = false;
            }
          })
         }catch(e) {

         }
      },
      // 下载模板
      rjz_handleDownload_MB() {

        let cid=sessionStorage.getItem('cid');

          let token=sessionStorage.getItem('token');
        window.location.href = this.$rootUrl+'export/downImportTemplate?cid='+cid+'&token='+token + "&templateName=日记账导入模板.xlsx";
      },
      // 导出功能
      handleExport(arr) {
        if(this.ProhibitClick) {
          return;
        }
         let listData = this.printFormData.checkList.filter(i=>{
          return (i!=="1") && (i!=="2") && (i!=="3") && (i!=="4")
        })
          let params = {
            cid: sessionStorage.cid,
            token: sessionStorage.token,
            printingMode:this.printFormData.exportScope,     // 打印或者导出范围 1=当前勾选 2=当前期间
            fkJournalAccountId: this.formData.fkJournalAccountId,
            startYearPeriods: this.formData.startYearPeriods,
            endYearPeriods: this.formData.endYearPeriods,
            ids:this.ids.join(','),
            customClumns:listData.join(','),     // 所选自定义列 以,号隔开
          }
          const router =this.$router.resolve({
          path: '/export/exportJournalPeriod',
          query: params
        })
          this.exportDialogShow = false;
        window.location.href = this.$rootUrl + router.href;
      },
      // 打印功能 
      handlePrint(type) {
        if(this.ProhibitClick) {
          return;
        }
        if(this.printFormData.exportScope==="1"&&!this.ids.length) {
          return this.$message.warning('检测到当前无勾选数据！')
        }
        let listData = this.printFormData.checkList.filter(i=>{
          return (i!=="1") && (i!=="2") && (i!=="3") && (i!=="4")
        })
        if(this.printFormData.exportType==="1"&&type) {
          this.handleExport();
          return 
        }
          const params = {
            cid: sessionStorage.cid,
            token: sessionStorage.token,
            printingMode:this.printFormData.exportScope,     // 打印或者导出范围 1=当前勾选 2=当前期间
            ids:this.ids.join(','),
            customClumns:listData.join(','),     // 所选自定义列 以,号隔开
            fkJournalAccountId: this.formData.fkJournalAccountId,
            startYearPeriods: this.formData.startYearPeriods,
            endYearPeriods: this.formData.endYearPeriods,
            type:type,     // 打印日记账and导出日记账pdf格式 type=export为导出
          }
          const router = this.$router.resolve({
            path: '/createPDF/printDiary',
            query: params
          })
          this.printDialogShow = false;
          this.exportDialogShow = false;
          window.open(this.$rootUrl + router.href, '_blank');
      },
      // 获取打印导出导入按钮权限
      getButtonAuthorize() {
        const _ = this;
        let params={
          permissions:'ac:diary:print,ac:diary:import,ac:diary:export'
        }
         _.$http.post('sys/menu/findPermissionMenu',params).then(res=>{
            if(res && res.data.code == 1) {
              _.buttonList = res.data.data;
            }
         })

         // 获取删除按钮
         let params_d={
          permissions:'ac:diary:deleted'
        }
         _.$http.post('sys/menu/findPermissionMenu',params_d).then(res=>{
            if(res && res.data.code == 1) {
              _.buttonList_d = res.data.data;
            }
         })
      },
      getDataChange(value) {
        this.formData.startYearPeriods = value[0];
        this.formData.endYearPeriods = value[1];
        this.formData.date =  value[1];
        this.formAdd.date = value[2];
          this.newAdds = false,
          this.getData();
      },
      getData(){//获取日记账
        const _=this;
        _.$set(_,'ProhibitClick',false);
        _.table.loading = true;
        _.$http.post('journal/findJournalPeriodAll',_.formData).then(res=>{
           _.table.loading = false;
           _.loadingText = "查询列表数据中";
           if(res && res.data.code == '1'){
             let list = res.data.data.data;
             this.table.tablePage.totalResult = res.data.data.total===0?res.data.data.total:res.data.data.total-1;
             list.forEach((item,index)=>{
              item.createUser = {
                value:item.createUser
              }
              // 为最后一行添加样式
              if(this.newAdds&&index===list.length-1) {
                  item.backgroundColor= "#eff9f6";
              }else {
                  item.backgroundColor= "";
              }
              // 自定义余额
              if(index<list.length-1) {

                 list[index+1].remainingSum = (Number(list[index].remainingSum)+Number(list[index+1].debitMoney)-Number(list[index+1].creditorMoney)).toFixed(2);
              }
               item.debitMoney = item.debitMoney?item.debitMoney:"";
               item.creditorMoney = item.creditorMoney?item.creditorMoney:"";
               item.remainingSum = item.remainingSum?item.remainingSum:"";
               item.btnContorl = {data:false,smmary:false,debitMoney:false,creditorMoney:false,remakes:false,remainingSum:false}
             });
             if(list.length > 0){
               _.nums = list[list.length-1].remainingSum;
             }else{
               _.nums = '';
             };
             _.tableData = JSON.parse(JSON.stringify(list));
             this.table.data = list;
            // _.findList(this.table.tablePage.currentPage,this.table.tablePage.pageSize);
             if(list.length > 0){
                _.formAddAmount.remainingSum = list[0].remainingSum;
              }else{
                _.formAddAmount.remainingSum  = 0;
              };
           }else{
              _.formAddAmount.remainingSum = 0;
              _.tableData.splice(0);
           }
          //表格滚动条展示到最下面
          // _.$nextTick(()=>{
          //   _.$refs.tableRefs.bodyWrapper.scrollTop = _.$refs.tableRefs.bodyWrapper.scrollHeight;
          // });
        }).catch(e=>{
          _.tableLoading = false;
          _.tableData.splice(0)
        });
        _.$http.post('journal/findBeginning',_.formData).then(res=>{
            if(res && res.data.code == '1'){
              _.edtBeginning = res.data.data.edtBeginning;
            }
        });
        Object.assign(_.formAdd,{
          //date:_.formData.date+'-01',
          summary:'',
          debitMoney:'',
          creditorMoney:'',
          remarks:'',
        });
       // _.$refs.addFormRef.resetFields();
        let d = new Date();
        let newY = d.getFullYear()+'-'+((d.getMonth()+1) < 10 ? '0'+(d.getMonth()+1) : (d.getMonth()+1));
        if(newY == _.formData.date){
         // _.formAdd.date = _.formData.date+'-'+d.getDate();
        }else{
          if(_.formData.date != null && _.formData.date != ''){
            //_.formAdd.date = _.formData.date+'-01';
          }
        }
        _.$setSessionStorage('yearsPeriod',_.formData.date.replace('-',''));
      },
      getData1(val){
        const _=this;
        _.ids=[];
        this.newAdds = false;
        let items = _.dictListCode.account.find(item=>{
          if(item.id == val){
            return item;
          }
        });

        let dates = new Date(items.yearPeriods);
        _.formData.date = dates.getFullYear()+''+((dates.getMonth()+1) < 10 ? '0'+(dates.getMonth()+1) :(dates.getMonth()+1));
        _.getData();
      },
      handleSetUser() {
        this.cashierdiaryTipsShow = false;
        this.$router.push('./cashieraccount')
      },
      getAllAccount(){//获取所有的账户/
        const _=this;
        _.$http.post('journal/findAccount',{type:-1}).then(res=>{
          if(res && res.data.code == '1'){
            if(res.data.data.length===0) {
                this.formData.fkJournalAccountId = "";
                this.cashierdiaryTipsShow = true;
            }else {
              this.cashierdiaryTipsShow = false;
            }
            

            _.del_useList = JSON.parse(JSON.stringify(res.data.data))
            _.del_useList.unshift({
              name:"全部",
              id:""
            })
            _.dictListCode.account =  _.del_useList;
            _.formData.fkJournalAccountId =  _.formData.fkJournalAccountId?_.formData.fkJournalAccountId:res.data.data[0].id;

            let dates = new Date(res.data.data[0].yearPeriods);
           // _.formData.startYearPeriods = dates.getFullYear()+''+((dates.getMonth()+1) < 10 ? '0'+(dates.getMonth()+1) :(dates.getMonth()+1));
            // _.formData.endYearPeriods = dates.getFullYear()+''+((dates.getMonth()+1) < 10 ? '0'+(dates.getMonth()+1) :(dates.getMonth()+1));
            if(this.firstGetTable) {
              this.firstGetTable = false;
               _.getData();
            }
           
            this.formData.date = dates.getFullYear()+''+((dates.getMonth()+1) < 10 ? '0'+(dates.getMonth()+1) :(dates.getMonth()+1));
           // this.dateList = [_.formData.startYearPeriods,_.formData.endYearPeriods]
             this.formAdd.date = dates.getFullYear()+'-'+((dates.getMonth()+1))+"-"+"1";
          }
        }).catch(e=>{

        });
      },
      keyUpEnterDown(key){//enter时间
        const _=this;
        if(!this.formData.fkJournalAccountId) {
            return  _.$message.error('出纳账户不能为空！')
        }
        switch(key){
          case 'date':
          if(_.formData.date != '' && _.formData.date != null){
           // _.formAdd.date = _.formData.date+'-01';
            _.$refs.dateRef.blur();
            _.$refs.sumaryRef.focus();
          }else{
            _.$message.error('日期不能为空！')
          }
          break;
          case 'summary':
            if(_.formAdd.summary != ''){
              _.$refs.debitMoneyRef.focus();
            }
          break;
          case 'debitMoney':
              if(_.formAdd.debitMoney != '') {
                   _.$refs.remarksRef.focus();
              }else {
                 _.$refs.creditorMoneyRef.focus();
              }
          break;
          case 'creditorMoney':
            if(_.formAdd.debitMoney == ''&&_.formAdd.creditorMoney == ''){
                _.$refs.debitMoneyRef.focus();
            }else {
                 _.$refs.remarksRef.focus();
            }
          break;
          case 'remarks':
           if(_.formAdd.summary === ''){
             // _.saveJournalPeriod(row);
               _.$refs.sumaryRef.focus();
            }else {
               _.saveJournalPeriod(this.formAdd);
            } 
            _.$refs.remarksRef.blur();
          break;
          case 'remainingSum':
             // _.saveJournalPeriodsrow();
            _.$refs.remainingSumRef.blur();
          break;
        };

      },
      filters(key,row){//筛选值
        const _=this;
        switch(key){
          case 'remainingSum':
           _.formAddAmount.remainingSum = _.formAddAmount.remainingSum.toString().replace(/[^0-9.-]/g,'');
          break;
          case 'debitMoney':
           _.formAdd.debitMoney= _.formAdd.debitMoney.toString().replace(/[^0-9.-]/g,'');
          break;
          case 'creditorMoney':
           _.formAdd.creditorMoney = _.formAdd.creditorMoney.toString().replace(/[^0-9.-]/g,'');
          break;
          case 'remainingSum1':
           row.remainingSum = row.remainingSum.toString().replace(/[^0-9.-]/g,'');
          break;
          case 'debitMoney1':
           row.debitMoney= row.debitMoney.toString().replace(/[^0-9.-]/g,'');
          break;
          case 'creditorMoney1':
           row.creditorMoney = row.creditorMoney.toString().replace(/[^0-9.-]/g,'');
          break;
        }
      },
      saveJournalPeriodsrow1_enter(row,key){
          row.btnContorl.remainingSum = false;
      },
      saveJournalPeriodsrow1(row,key){
        const _=this;

        const prevent =  this.$getSessionStorage('superPreventOperation');
        if(prevent) {
          this.$store.commit('SUPERPREVENTFUNCTION',true);
          return;
        }
        let data = JSON.parse(JSON.stringify(_.formAddAmount));
        data.fkJournalAccountId = _.formData.fkJournalAccountId;
        data.date = _.formData.date;
        if(row.remainingSum) {
          data.remainingSum = row.remainingSum.toString().replace(/\,/g,"");
           data.remainingSum = parseFloat(data.remainingSum)
        }
       _.$http.post('journal/saveJournalPeriod',data).then(res=>{
            _.table.loading = false;
            _.newAdds = false;
            if(res && res.data.code == '1'){
              _.getData();
            }
        }).catch(e=>{
          _.table.loading = false;
        });
      },
      saveJournalPeriodsrow(){//保存期初余额
        const _=this;
       
        const prevent =  this.$getSessionStorage('superPreventOperation');
        if(prevent) {
          this.$store.commit('SUPERPREVENTFUNCTION',true);
          return;
        }
        let data = JSON.parse(JSON.stringify(_.formAddAmount));
        data.fkJournalAccountId = _.formData.fkJournalAccountId;
        data.date = _.formData.date;
        if(data.remainingSum) {
            data.remainingSum = data.remainingSum.toString().replace(/\,/g,"");
            data.remainingSum = parseFloat(data.remainingSum)
        }
        if(!_.table.loading){
          _.table.loading = true;_.newAdds = false;
          _.$http.post('journal/saveJournalPeriod',data).then(res=>{
              _.table.loading = false;
              if(res && res.data.code == '1'){
                _.getData();
              }
          }).catch(e=>{
            _.table.loading = false;
          });
        }
      },
      saveJournalPeriod(row,status){//保存日记账
        const _=this;

        const prevent =  this.$getSessionStorage('superPreventOperation');
        if(prevent) {
          this.$store.commit('SUPERPREVENTFUNCTION',true);
          return;
        }
        //  if(_.formAdd.debitMoney==""&&_.formAdd.creditorMoney=="") {

        //   return _.$message.warning('需要填入收入或支出')
        // }
        // if(_.formAdd.debitMoney!=""&&_.formAdd.creditorMoney!="") {
        //   return _.$message.warning('收入和支出只能填写一个哟')
        // }
        //  if(_.formAdd.debitMoney!=""&&!Number(_.formAdd.debitMoney)) {
        //       _.formAdd.debitMoney = parseFloat(_.formAdd.debitMoney);
        // }
        // if(_.formAdd.creditorMoney!=""&&!Number(_.formAdd.creditorMoney)) {
        //      _.formAdd.creditorMoney = parseFloat(_.formAdd.creditorMoney);
        // }
       // _.$refs.addFormRef.validate((valide)=>{
          //console.log(status)
          //if(valide || status){
            let data = JSON.parse(JSON.stringify(row));
            data.fkJournalAccountId = _.formData.fkJournalAccountId;
            _.table.loading = true;
            _.$http.post('journal/saveJournalPeriod',data).then(res=>{
                _.table.loading = false;
                if(res && res.data.code == '1'){
                  _.$message.success("保存成功！")
                  _.newAdds = true;
                 _.getData();
                //  _.$refs.addFormRef.resetFields();
                  Object.assign(_.formAdd,{
                    summary:'',
                    debitMoney:'',
                    creditorMoney:'',
                    remarks:'',
                  });
                  _.$refs.dateRef.focus();
                 // let d = new Date();
                 // let newY = d.getFullYear()+'-'+((d.getMonth()+1) < 10 ? '0'+(d.getMonth()+1) : (d.getMonth()+1));
                 // if(newY == _.formData.date){
                   // _.formAdd.date = _.formData.date+'-'+d.getDate();
                 // }else{
                    //_.formAdd.date = _.formData.date+'-01';
                 // }
                }else {
                  _.getData();
                }
            }).catch(e=>{
              _.table.loading = false;
            });
         // }
       // });
      },
      deletList(row){//删除条
        const _=this;

        const prevent =  this.$getSessionStorage('superPreventOperation');
        if(prevent) {
          this.$store.commit('SUPERPREVENTFUNCTION',true);
          return;
        }
        if(_.ProhibitClick) {
          return;
        }
        _.$confirm('确定删除 '+row.summary+' 这条数据吗？','删除',{
            confirmButtonText:'确定删除',
            cancelButtonText:'取消',
            type:'warning'
        }).then(()=>{
          _.deleteJournalAxios(row.id);
        });
      },

      // 批量删除
      deleteAlls(){
        const _=this;

        const prevent =  this.$getSessionStorage('superPreventOperation');
        if(prevent) {
          this.$store.commit('SUPERPREVENTFUNCTION',true);
          return;
        }
        if(_.ProhibitClick) {
          return;
        }
        if(_.ids.length <= 0){
          _.$message.error('请先选择要删除的数据！');
        }else{
          _.$prompt('您将删除选中的'+_.ids.length+'条数据,您可在输入框输入删除原因(可选)？','删除',{
             confirmButtonText:'确定删除',
             cancelButtonText:'取消',
             inputPlaceholder:"可输入删除原因",
          }).then((val)=>{
            _.deleteJournalAxios(_.ids.join(','),val.value);
          });
        }
      },
      deleteJournalAxios(ids,reason){//删除
        const _=this;
        _.$http.post('journal/deleteJournalPeriod',{ids:ids,because:reason}).then(res=>{
          _.newAdds = false;
           if(res && res.data.code =='1'){
              _.$message.success(res.data.msg);
              _.table.loading = true;
              _.getData();
           };
        }).catch(e=>{

        });
      },
      getSummaries(param){
        const { columns, data } = param;
        const sums = [];
        let datas = JSON.parse(JSON.stringify(data));
        columns.forEach((column, index) => {
          if(index === 0) {
            sums[index] = '';
            return;
          }else if(index == 1){
            sums[index] = '合计';
            return;
          }else if(index == 2){
            sums[index] = '共'+(data.length-1)+'条';
            return;
          }else if(index == 5){
            sums[index] = this.nums;
            return;
          }else if(index == 6 || index == 7){
            sums[index] = '';
            return;
          }
          if(datas.length) {
            datas.forEach(i=>{
              if(i.creditorMoney) {
                  i.creditorMoney = i.creditorMoney.toString().replace(/\,/g,"");
              }
              if(i.debitMoney) {
                   i.debitMoney = i.debitMoney.toString().replace(/\,/g,"");
              }

              if(i.remainingSum) {
                 i.remainingSum = i.remainingSum.toString().replace(/\,/g,"");
              }

               
            })
          }
          const values = datas.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            let sumsIndex = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            sums[index] = currencys(sumsIndex);
          } else {
            sums[index] = 'N/A';
          }
        });
        return sums;
      },
      btnContrl(el,key){//打开列表修改内容
        const _=this;
        if(_.ProhibitClick) {
          return ;
        }

        if(key == 'remainingSum' && el.isBeginning == 1 && _.edtBeginning){
          _.$set(el.btnContorl,key,true);
        }else if(key != 'remainingSum' && el.isBeginning != 1){

          _.$set(el.btnContorl,key,true);
        }
      },
      // 列表enter强行失去焦点
       editListDatas(el,key){
          el.btnContorl[key] = false
       },
      editListData(el,key){//修改列表的数据
        const _=this;

       const prevent =  this.$getSessionStorage('superPreventOperation');
        if(prevent) {
          this.$store.commit('SUPERPREVENTFUNCTION',true);
          return;
        }
        if(key == 'debitMoney' || key == 'creditorMoney') {
            if(el.creditorMoney) {
                 el.creditorMoney=el.creditorMoney.toString().replace(/\,/g,"");
                  el.creditorMoney = parseFloat(el.creditorMoney)
            }

             if(el.debitMoney) {
                 el.debitMoney=el.debitMoney.toString().replace(/\,/g,"");
                  el.debitMoney = parseFloat(el.debitMoney)
            }
            if((isNaN(el.creditorMoney)) || isNaN(el.debitMoney)) {
                el.creditorMoney="";
                el.debitMoney="";
             }
        }
       
        if(key == 'debitMoney'){

            if(el[key] != 0){
                el.creditorMoney = "";
                 el.btnContorl.creditorMoney = false;
                  el.btnContorl.debitMoney = false;
                   _.ProhibitClick = false;
            }else {
              if(!Number(el.creditorMoney)){
                  el.btnContorl.creditorMoney = true;
                  el.btnContorl.debitMoney = true;
                  _.ProhibitClick = true;
              }else {
                 el.btnContorl.creditorMoney = false;
                  el.btnContorl.debitMoney = false;
                   _.ProhibitClick = false;
              }
            }
        }else if(key == 'creditorMoney'){
            if(el[key] != 0){
                el.debitMoney = "";
                el.btnContorl.creditorMoney = false;
                  el.btnContorl.debitMoney = false;
                   _.ProhibitClick = false;
            }else {
              if(!Number(el.debitMoney)){
                  el.btnContorl.creditorMoney = true;
                  el.btnContorl.debitMoney = true;
                   _.ProhibitClick = true;
                   
              }else {
                 el.btnContorl.creditorMoney = false;
                  el.btnContorl.debitMoney = false;
                   _.ProhibitClick = false;
              }
            }

        }else if(key == 'data'){
             _.$set(el.btnContorl,key,false);
        };


        if(_.ProhibitClick) {
              if(_.changeFocus) {
                   _.changeFocus = !_.changeFocus;
                   _.$refs.debitMoneyRefs.focus();
              }else {
                 _.changeFocus = !_.changeFocus;
                _.$refs.creditorMoneyRefs.focus();
              }

              if(_.firstHit) {
                _.firstHit= false;
                _.$message.warning("收入支出不能同时为零或者为空，且只能为数字，请确认后操作！")
              }

                return;
              
           }
        let datas = JSON.parse(JSON.stringify(el));
        if(key != 'creditorMoney'&& key != 'debitMoney') {
              _.$set(el.btnContorl,key,false);
          
        }
        datas.fkJournalAccountId = _.formData.fkJournalAccountId;
        delete datas.btnContorl;

         if(datas.creditorMoney) {
                 datas.creditorMoney=datas.creditorMoney.toString().replace(/\,/g,"");
                  datas.creditorMoney = parseFloat(datas.creditorMoney)
            }

             if(datas.debitMoney) {
                 datas.debitMoney=datas.debitMoney.toString().replace(/\,/g,"");
                  datas.debitMoney = parseFloat(datas.debitMoney)
            }
        if(datas.remainingSum) {
             datas.remainingSum=datas.remainingSum.toString().replace(/\,/g,"");
              datas.remainingSum = parseFloat(datas.remainingSum)
        }
       if(!Number(datas.creditorMoney) && !Number(datas.debitMoney)) {
           return _.$message.warning("收入支出只能是数字！")
       }else {
           _.loadingText = '保存列表数据中';_.tableLoading = true;
            _.$http.post('journal/saveJournalPeriod',datas).then(res=>{
                _.tableLoading = false;
                _.getData();
            }).catch(e=>{
              _.tableLoading = false;
            });
         }
       
      },
      pickerOptions(){//只能够选择当前月份的日期
      	let _=this;
      	return {
      		disabledDate(date){
      			let d1 = new Date(_.formData.date);
      			let y1 = d1.getFullYear();let m1 = d1.getMonth();
      			let s = y1+'-'+(m1+1);let e = y1+'-'+(m1+2);
      			return date.getTime() < new Date(s) || date.getTime() >= new Date(e);
      		}
      	}
      },
      isTableDisabled(row, index){//禁用期初余额的数据
         if(row.isBeginning == 1){
           return false;
         }else{
           return true;
         }
      },
      selections(selection){//多选发送变化时
        const _=this;
        _.ids.splice(0);
        selection.forEach(item=>{
          _.ids.push(item.id);
        });
        console.log(_.ids);
      },
      //页码发送变化
      pageIndexChange(page){
      	this.page.pageIndex = page;
      	this.getData();
      },//页码条数发送变化
      pageSizeChange(page){
      	this.page.pageSize = page;
      	this.getData();
      },
      golbeClick() {
        if(this.table.data.length>1){

          this.table.data[1].backgroundColor="";
        }
          this.$refs.vxeTable.$children[0].clearActived();
          this.newAdds = false;
      },
     
    },
    mounted(){

      ///全局禁用 空格键
      if(this.$refs.debitMoneyRef) {
        this.$refs.debitMoneyRef.$el.onkeydown = function(e) {
          //禁用数字键 .- del 以外的所有键盘
          if((e.keyCode >= 48 && e.keyCode<=57) || (e.keyCode >= 96 && e.keyCode<=105) || e.keyCode == 190  || e.keyCode == 110 || e.keyCode == 109  || e.keyCode == 189  || e.keyCode == 8 || e.keyCode == 9 || e.keyCode == 39 || e.keyCode == 37) {
          }else{
            window.event.returnValue= false;
          }
        };
      }
      if(this.$refs.creditorMoneyRef) {
        this.$refs.creditorMoneyRef.$el.onkeydown = function(e) {
          //禁用数字键 .- del 以外的所有键盘
          if((e.keyCode >= 48 && e.keyCode<=57) || (e.keyCode >= 96 && e.keyCode<=105) || e.keyCode == 190  || e.keyCode == 110 || e.keyCode == 109  || e.keyCode == 189  || e.keyCode == 8 || e.keyCode == 9 || e.keyCode == 39 || e.keyCode == 37) {
          }else{
            window.event.returnValue= false;
          }
        }
      }
      
    }, 
    created(){
       let dates = new Date();
       this.dateList[0] = this.$util.formatDate.format(dates , 'yyyyMM');
       this.dateList[1] = this.$util.formatDate.format(dates , 'yyyyMM');
         this.formData.startYearPeriods = dates.getFullYear()+''+((dates.getMonth()+1) < 10 ? '0'+(dates.getMonth()+1) :(dates.getMonth()+1));
         this.formData.endYearPeriods = dates.getFullYear()+''+((dates.getMonth()+1) < 10 ? '0'+(dates.getMonth()+1) :(dates.getMonth()+1));      

      document.body.addEventListener('click',this.golbeClick)
      this.getAllAccount();
      this.getButtonAuthorize();
      this.getPDFcustom();
    },
    computed: {
  
      getClickCache() {
        return this.$store.state.loadstatus.isClickCache;
      }
    },
    deactivated() {
       document.body.removeEventListener('click',this.golbeClick)
    },
    activated() {
      this.newAdds = false;
      if(this.isFirstActive) {
          this.getAllAccount();
      }
      this.isFirstActive = true;
       document.body.addEventListener('click',this.golbeClick)
    },
    watch:{
      isFastAddShow(val) {
          if(val) {
                ///全局禁用 空格键
                if(this.$refs.debitMoneyRef) {
                  this.$refs.debitMoneyRef.$el.onkeydown = function(e) {
                    //禁用数字键 .- del 以外的所有键盘
                    if((e.keyCode >= 48 && e.keyCode<=57) || (e.keyCode >= 96 && e.keyCode<=105) || e.keyCode == 190  || e.keyCode == 110 || e.keyCode == 109  || e.keyCode == 189  || e.keyCode == 8 || e.keyCode == 9 || e.keyCode == 39 || e.keyCode == 37) {
                    }else{
                      window.event.returnValue= false;
                    }
                  };
                }
                if(this.$refs.creditorMoneyRef) {
                  this.$refs.creditorMoneyRef.$el.onkeydown = function(e) {
                    //禁用数字键 .- del 以外的所有键盘
                    if((e.keyCode >= 48 && e.keyCode<=57) || (e.keyCode >= 96 && e.keyCode<=105) || e.keyCode == 190  || e.keyCode == 110 || e.keyCode == 109  || e.keyCode == 189  || e.keyCode == 8 || e.keyCode == 9 || e.keyCode == 39 || e.keyCode == 37) {
                    }else{
                      window.event.returnValue= false;
                    }
                  }
                }
          }
      }
    }
  }
</script>

<style lang="less">
 #printDialog_ss {
      .el-dialog__header {
        border-bottom: 1px solid #eee;
      }
      .printTitle {
        font-weight: bold;
        color: #666;
      }
      .el-checkbox {
        margin-bottom: 10px;
      }
      
    }
  #cashierdiary{
    height: calc(100% - 60px);
    position: relative;
    .flexTable {
        position: absolute;
        width:calc(100% - 60px);
        bottom: 0;

    }
    .lineHeight {
      margin-top: 5px;
      .el-form-item__content {
        line-height: 0px;
      }
    }
    .handleSetUserStyle{
        .el-dialog__body {
          padding:0 20px 10px;
        }
    }
    /*账户提示框*/
    .cashierdiaryTips{
        position: absolute;
        width: 225px;
        height: 38px;
        border: 2px solid red;
        z-index: 999;
        left:-5px;
    }
    /**/
    /*自定义列*/
        .table-oper {
          display:inline-block;

        }
        .menu-btn {
          position: relative;
          float: right;
          &:hover {
            .menu-wrapper {
              display: block;
            }
          }
        }
        .menu-wrapper {
          line-height: 20px;
          display: none;
          position: absolute;
          width: 120px;
          top: 30px;
          right: -6px;
          z-index: 9999;
          background-color: #fff;
          font-size: 14px;
          user-select: none;
          border: 1px solid #e8eaec;
          .checkbox-item {
            display: block;
            margin: 4px 0;
            padding: 4px 10px;
          }
          .allChange {
              border-bottom: 1px solid #ddd;
          }
        }

    /**/
    .fade-enter,.fade-leave-to {
        opacity: 0;
        transform: translateY(-30px);
    }
    .fade-enter-active ,.fade-leave-active {
        transition: all .2s linear;
    }
    .el-input--small .el-input__inner {
        height: 32px !important;
        line-height: 32px;
    }
    .rangeDate {
      position: relative;
    }
    .click_container {
      width: 100%;
      height: 100%;
      padding:0;
      display: block;
      position: relative;
    }
    .fliesUplaod{
      .fliesUplaod_text {
        color: #EC681D;
        display: inline-block;
        margin-bottom: 20px;
      }
      .handleDownload {
        margin: 3px 0 18px 0;
      }
      .uploads{
        padding:15px 0px;
        .el-upload-dragger {
          width: 250px;
          height: 90px;
          .el-icon-upload {
            font-size: 35px;
            margin: 0;
            line-height: 45px;
          }
        }
      }

      /*new*/
      .stepOne {
        p {
          margin-top: 10px;
          margin-left: 30px;
        }
      }
      .stepTwo {
        margin-top: 20px;
        p{
          margin-left: 30px;
        }
      }
    }
    .dialog-footer {
      text-align: right;
    }
    .RJZ_dialog {
      .el-dialog {
        .el-dialog__header {
          padding: 17px 20px;
          border-bottom: 1px solid #E5E5E5;
          .el-dialog__title {
            color: #333;
            font-size: 14px;
            font-weight: 600;
          }

        }
        .el-dialog__body {
              padding: 18px 20px;
        }
      }
    }
    .addDiary-content,.addAmount{
      padding:10px;
      width:calc(100% - 22px);
      border:solid 1px #EBEEF5;
      margin-bottom: 20px;
      border-radius:4px;
      .saveRjzBtn {
        background-color: #20BD90;
        color: #fff;
        border-radius: 14px;
        padding: 9px 18px;
        margin: 30px 0 0 30px;
      }
      .el-form-item{
        margin-bottom: 10px;
      }
      .el-form-item__label{
          line-height: 30px;
          padding-bottom: 0;
      }
    }
    .addDiary-content{
      .el-input__inner::-webkit-input-placeholder{
        text-align: right
      }
    }
    .nothing {
      color: #269D7B;
    }
    .junoders{
       
    }

    .newAdd{
      .vxe-table--body-wrapper{
        .vxe-body--row {
            &:last-child{
              background-color: #eff9f6;
            }           
        }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cashier/cashierdiary - 副本.vue